import { render } from "./AddPurchaseRequest.vue?vue&type=template&id=4bb297fa"
import script from "./AddPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./AddPurchaseRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__